import { useEffect, useRef, useState } from "react";
import { Grid } from "../../../../../../Layout/Grid/GridView";
import Loading from "../../../../../../../components/Loading";
import GenresComponent from "../components/GenresComponent";
import AgeComponent from "../components/AgeComponent";

const GuestlistStatsView = ({ data }) => {
  const gridGuestListEntriesRef = useRef();
  const [gridList, setgridList] = useState([])




  return data ? (
    <div>
      <div className="row">
        <div className="col-12 col-sm-4">
          <div className="card card-stats mb-4 mb-xl-0 cards-bg ">
            <div className="card-body card-body-bg-dark box-venue">
              <div className="row">
                <div className="col">
                  <h5 className="card-title text-uppercase text-muted mb-0">
                    Nº Registos
                  </h5>
                  <span className="h2 font-weight-bold mb-0">
                    {data.numberRegistries}
                  </span>
                </div>
                <div className="col-auto">
                  <div className="icon icon-shape bg-danger text-light text-white rounded-circle shadow">
                    <i
                      className="fas fa-chart-bar text-light"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </div>
                </div>
              </div>
              <p className="mt-3 mb-0 text-muted text-sm">&nbsp;</p>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-4">
          <div className="card card-stats bg-dark mb-4 mb-xl-0 cards-bg ">
            <div className="card-body card-body-bg-dark box-venue">
              <div className="row">
                <div className="col">
                  <h5 className="card-title text-uppercase text-muted mb-0">
                    Nº Entradas
                  </h5>
                  <span className="h2 font-weight-bold mb-0">
                    {data.numberEntries}
                  </span>
                </div>
                <div className="col-auto">
                  <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                    <i
                      className="fa-solid fa-user-check text-light"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </div>
                </div>
              </div>
              <p className="mt-3 mb-0 text-muted text-sm">&nbsp;</p>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-4">
          <div className="card card-stats bg-dark mb-4 mb-xl-0 cards-bg ">
            <div className="card-body card-body-bg-dark box-venue">
              <div className="row">
                <div className="col">
                  <h5 className="card-title text-uppercase text-muted mb-0">
                    Taxa de conversão
                  </h5>
                  <span className="h2 font-weight-bold mb-0">
                    {data.taxSuccess}%
                  </span>
                </div>
                <div className="col-auto">
                  <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                    <i
                      className="fa-solid fa-percent text-light"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </div>
                </div>
              </div>
              <p className="mt-3 mb-0 text-muted text-sm">&nbsp;</p>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-12 col-sm-3 mb-3 mb-sm-0">
          <div className="box-venue card-body-bg-dark">
            <GenresComponent data={data} />
          </div>
        </div>
        <div className="col-12 col-sm-9 mb-3 mb-sm-0">
          <div className="box-venue card-body-bg-dark">
            <AgeComponent data={data} />
          </div>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-12">
          <Grid
            ref={gridGuestListEntriesRef}
            rows={data.list_entries}
            height="100vh"
            pagination={true}
            cols={[

              { headerName: "Data Inscrição", field: "datetime" },
              { headerName: "Nome", field: "name" },
              { headerName: "Idade", field: "age" },
              { headerName: "Genero", field: "gender" },
              {
                headerName: "Check-In", field: "check_in", cellRenderer: (params) => {
                  return (
                    <div className="text-center">
                      {params.data.check_in ? (
                        <i className="fa-solid fa-check text-success"></i>
                      ) : (
                        <i className="fa-solid fa-times text-danger"></i>
                      )}
                    </div>
                  );
                },
              },
              { headerName: "Hora Check-In", cellStyle: { textAlign: 'center' }, field: "check_in_datetime" },
            ]}
          />
        </div>
      </div>
    </div>
  ) : <Loading />;
};

export default GuestlistStatsView;
